import { CoachTqReviewType } from '@airreading/common/data';

export const CoachTqReviewTypeBadgeClassMap: Record<CoachTqReviewType, string> = {
  [CoachTqReviewType.QR_New_First]: 'bg-amber-100 text-amber-800 border-amber-200',
  [CoachTqReviewType.FR_New_Second]: 'bg-sky-100 text-sky-800 border-sky-200',
  [CoachTqReviewType.FR_Current]: 'bg-violet-100 text-violet-800 border-violet-200',
  [CoachTqReviewType.QR_Return]: 'bg-rose-100 text-rose-800 border-rose-200',
  [CoachTqReviewType.Assessment]: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  [CoachTqReviewType.PM_GLA]: 'bg-teal-100 text-teal-800 border-teal-200',
};
